import {
  deleteV1DealerIdBorrowerBorIdEmploymentEmpId,
  getV1DealerIdBorrowerBorIdEmployments,
  postV1DealerIdBorrowerBorIdEmployment,
  putV1DealerIdBorrowerBorIdEmploymentEmpIdUpdateEmployment,
  type DtoCreateEmploymentReq,
  type DtoUpdateEmploymentReq,
} from "@porchpass/api-client";
import {
  assertApiSuccess,
  assertApiSuccessNoContent,
} from "../utils/assertApiSuccess";
import { EMPTY_REQUEST_BODY } from "./constants";
import { lazyDealerId, requireBorrowerId, type DomainIds } from "./types";

export function createEmploymentDomain(ids: DomainIds) {
  const getDealerId = lazyDealerId(ids);

  return {
    getEmployments: async (borrowerId?: string) => {
      const borId = requireBorrowerId(borrowerId ?? ids.borrowerId);
      const response = await getV1DealerIdBorrowerBorIdEmployments(
        getDealerId(),
        borId,
        EMPTY_REQUEST_BODY,
      );
      return assertApiSuccess(response);
    },

    createEmployment: async (
      body: DtoCreateEmploymentReq,
      borrowerId?: string,
    ) => {
      const borId = requireBorrowerId(borrowerId ?? ids.borrowerId);
      const response = await postV1DealerIdBorrowerBorIdEmployment(
        getDealerId(),
        borId,
        body,
      );
      return assertApiSuccess(response);
    },

    updateEmployment: async (
      employmentId: string,
      body: DtoUpdateEmploymentReq,
      borrowerId?: string,
    ) => {
      const borId = requireBorrowerId(borrowerId ?? ids.borrowerId);
      const response =
        await putV1DealerIdBorrowerBorIdEmploymentEmpIdUpdateEmployment(
          getDealerId(),
          borId,
          employmentId,
          body,
        );
      return assertApiSuccess(response);
    },

    deleteEmployment: async (employmentId: string, borrowerId?: string) => {
      const borId = requireBorrowerId(borrowerId ?? ids.borrowerId);
      const response = await deleteV1DealerIdBorrowerBorIdEmploymentEmpId(
        getDealerId(),
        borId,
        employmentId,
        EMPTY_REQUEST_BODY,
      );
      assertApiSuccessNoContent(response);
    },
  };
}
